import React, { ComponentProps } from 'react';
import cms from '../../../data/cms.json';
import { Icon } from '../../Icon/Icon';
import styles from './Step9loading.module.scss';
import { getDataTest } from '../../../utils/dataTests';

const CountdownAlert = (props: Omit<ComponentProps<'div'>, 'children'>) => {
    return (
        <div className={styles.countdownAlert} {...props}>
            <Icon name="alertMegaphone" size="large" data-test={getDataTest(props, 'Icon')} />
            {cms.step9loader.countdownFinished}
        </div>
    );
};

export default CountdownAlert;
